import { IEvent } from 'libs/shared/interfaces/event.model';
import { Trail } from '@betrail-libs/shared/interfaces/interfaces';

export class EditTrailDialogData {
  trail: Trail;
  event: IEvent;
}
